import useAntTable from './useAntTable';
import { Table } from 'antd';


const AntTable = ({data,updateFn,deleteFn,switcherFn,isFetching,onChange,previewFn}) => {

const {generateColumns,generateRows} = useAntTable({data:data.data,updateFn,deleteFn,switcherFn,previewFn});

return (
  <Table
    columns={generateColumns() || []}
    dataSource={generateRows() || []}
    pagination={{ pageSize: data.meta?.take, total: data.meta?.itemCount, current: data.meta?.page }} 
    loading={isFetching}
    onChange={onChange}
  />
)}
export default AntTable;

